module.exports = __webpack_public_path__ + "img/bell_active.20dddaf2.svg";